import { Button, Classes, Dialog } from '@blueprintjs/core';
import { DatePicker } from '@blueprintjs/datetime';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface ExpirySelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSelected: (expiryDate: string | null) => void;
  initialExpiryDate?: string | null;
}

const ExpirySelectionDialog = ({
  isOpen,
  onClose,
  onSelected,
  initialExpiryDate,
}: ExpirySelectionDialogProps) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  useEffect(() => {
    if (isOpen) {
      if (initialExpiryDate) {
        const parsed = new Date(initialExpiryDate);
        setSelectedDate(parsed.getTime() ? parsed : null);
      } else {
        setSelectedDate(null);
      }
    }
  }, [isOpen, initialExpiryDate]);

  const handleConfirm = () => {
    const expiryDate =
      selectedDate == null
        ? null
        : selectedDate.toISOString().split('T')[0];
    onSelected(expiryDate);
    onClose();
  };

  return (
    <Dialog
      autoFocus
      canEscapeKeyClose
      canOutsideClickClose
      enforceFocus
      usePortal
      onClose={onClose}
      title={t('Add Expiry')}
      isOpen={isOpen}
    >
      <div className={Classes.DIALOG_BODY}>
        <p>
          <strong>{t('Select the document expiry date:')}</strong>
        </p>
        <div className={styles.calendarWrapper}>
          <DatePicker
            value={selectedDate ?? undefined}
            onChange={(date) => setSelectedDate(date)}
            minDate={new Date()}
            maxDate={
              new Date(new Date().setFullYear(new Date().getFullYear() + 10))
            }
          />
        </div>
        <div className="d-flex justify-content-end mt-2">
          <Button
            intent="danger"
            text={t('No expiry')}
            onClick={() => setSelectedDate(null)}
            disabled={selectedDate == null}
          />
        </div>
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onClose}>{t('Cancel')}</Button>
          <Button intent="primary" onClick={handleConfirm}>
            {t('Apply')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ExpirySelectionDialog;
